<script>
    import Card from '@smui/card';
    import Fab, {Label, Icon} from '@smui/fab';

    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function clear() {
        dispatch('delete');
    }

    export let editing = "";
    export let header="";
</script>

<div class="col-6 col-lg-8">
    <Card>
        <div class="cng-card__primary cng-card__header-with-buttons">
            <div class="mdc-typography--headline5">{header}</div>
            <div>
                {#if editing !== ""}
                    <Fab on:click={clear} class="button-shaped-round"><Icon class="material-icons">delete</Icon></Fab>
                {/if}
            </div>
        </div>
        <div class="cng-card__divider"></div>
        <div class="cng-card__secondary"><slot/></div>
    </Card>
</div>

<style>
    .cng-card__header-with-buttons {
        height: 92px;
    }
</style>
